import Skeleton from 'flow/components/ui-components/Skeleton';
import useAppContext from 'flow/hooks/useAppContext';

type Props = {
    label: string;
    value?: string;
    skeletonWidth: string;
};

const QuotaStatRow = ({ label, value, skeletonWidth }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex items-center justify-between px-2 py-2">
            <span>{i18next.t(label)}</span>
            {value !== undefined ? (
                <span className="font-bold">{value}</span>
            ) : (
                <Skeleton>
                    <Skeleton.Text className={`h-5 ${skeletonWidth}`} />
                </Skeleton>
            )}
        </div>
    );
};

export default QuotaStatRow;
